import React, { useEffect, useRef } from 'react';
import CollapsibleSection from '../../common/CollapsibleSection';
import SessionMonitoring from '../SessionMonitoring';

/**
 * Past sessions panel — search, history, archive, and overflow admin tasks.
 * Sessions already in Today's work are hidden from the "today" group here.
 */
const SessionsPastSection = ({
  clubId,
  defaultExpanded = false,
  scrollIntoView = false,
  excludeSessionIds = null,
  completedSessionAllMarked = null,
  onSessionsChange,
  clubLogoUrl = null,
  clubName = '',
  expanded,
  onExpandedChange,
}) => {
  const sectionRef = useRef(null);

  useEffect(() => {
    if (scrollIntoView && sectionRef.current) {
      sectionRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [scrollIntoView]);

  if (!clubId) return null;

  return (
    <div ref={sectionRef} id="sessions-past-section">
      <CollapsibleSection
        title="Past sessions"
        iconType="past-sessions"
        defaultExpanded={defaultExpanded}
        expanded={expanded}
        onExpandedChange={onExpandedChange}
        className="mb-0"
      >
        <SessionMonitoring
          clubId={clubId}
          embedded
          variant="past"
          excludeSessionIds={excludeSessionIds}
          completedSessionAllMarkedFromHub={completedSessionAllMarked}
          onSessionsChange={onSessionsChange}
          clubLogoUrl={clubLogoUrl}
          clubName={clubName}
        />
      </CollapsibleSection>
    </div>
  );
};

export default SessionsPastSection;
